import { useTranslation } from 'react-i18next';

import Modal, { IconBlock, Title, ActionBlock } from '@components/Modal';

interface PrintSuccessModalProps {
  onPrint: () => void;
  onConfirm: () => void;
  isPrinting?: boolean;
}

const languageNamespace = 'printing-modals';
const commonLanguageNamespace = 'common';

export const PrintSuccessModal = ({ onPrint, onConfirm, isPrinting }: PrintSuccessModalProps) => {
  const { t } = useTranslation([languageNamespace, commonLanguageNamespace]);

  return (
    <Modal minWidth="54rem">
      <IconBlock icon="checkMark" />
      <Title title={t('printSuccessful')} titleWeight="bolder" />
      <ActionBlock
        actions={[
          {
            appearance: 'secondary',
            text: t('reprint'),
            onClick: onPrint,
            isLoading: isPrinting,
          },
          {
            appearance: 'primary',
            text: t('common:close'),
            onClick: onConfirm,
            fullWidth: true,
          },
        ]}
      />
    </Modal>
  );
};
